import axiosInstance from "./axiosInstance";
import { getUrlForUsers } from "./confighelpers";

/**
 * Send a chat message to the AI Support LLM endpoint.
 * Sends conversation history so GPT has context.
 *
 * @param {Array<{role: string, content: string}>} messages - Chat history
 * @returns {Promise<{message: string}>} - The assistant's reply
 */
export async function sendAIChatMessage(messages) {
  // Strip out UI-only fields before sending to the API
  const cleanMessages = messages
    .filter((m) => m.role === "user" || m.role === "assistant")
    .map((m) => ({ role: m.role, content: m.content }));

  const response = await axiosInstance.post(
    `${getUrlForUsers()}aiSupportChat`,
    { messages: cleanMessages }
  );

  return response.data?.data;
}
